<template>
  <div class="hero-banner-fourteen lg-container mb-50">
    <div class="container">
      <div class="row">
        <div class="col-md-6 hero-column justify-content-center pt-30 md-pt-0 lg-pt-50">
          <h1 class="hero-heading" data-aos="fade-right" data-aos-delay="100">{{ content.title }}</h1>
          <div class="hero__text pe-xl-5"  data-aos="fade-right" data-aos-delay="200">
            <PortableText :value="content.blockText" />
          </div>
        </div>
        <div class="col-md-6 hero-column justify-content-center">
          <div class="panel-box"
               data-aos="fade-left"
               data-aos-delay="300">
            <div v-for="(panel, index) in reel"
                 :key="panel._key"
                 class="hero-panel"
                 :class="{ 'active': index === activeIndex }">
              <div class="hero-bg"></div>
              <img :src="panel?.image?.image?.asset.url"
                   :alt="panel?.alt"
                   class="hero-image"
                   height="500"
                   width="500">
              <div class="hero-label">
                <img :src="panel?.icon?.image?.asset.url"
                     :alt="panel?.icon?.alt"
                     class="hero-icon"
                     height="500"
                     width="500">
                <h4 class="hero-label__title">{{ panel.title }}</h4>
              </div>
            </div> <!-- /.screen-holder -->
          </div>
        </div>
      </div>
      <div class="row justify-content-center mt-100" data-aos="fade-up" data-aos-delay="400">
        <a :href="`mailto:sales@marshallprint.co.uk?subject=Inquiry&body=---%0AContext: Home page hero banner link`"
           class="btn btn-primary position-relative">
          Request a quote
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { PortableText } from "@portabletext/vue";

  export default {
  name: 'HeroBanner',
    components: {PortableText},
  props: {
    content: {
      type: Object,
      default: () => ({
        title: '',
        subtitle: '',
        image: {
          image: {
            asset: {
              url: ''
            }
          },
          alt: ''
        },
        icon: {
          image: {
            asset: {
              url: ''
            }
          },
          alt: ''
        },
        singleLink: {
          slug: {
            current: ''
          },
          text: ''
        }
      })
    },
    reel: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      interval: null
    };
  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    this.stopCarousel();
  },
  methods: {
    startCarousel() {
      this.interval = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.reel.length;
      }, 5000);
    },
    stopCarousel() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-banner-fourteen {
  padding: 6rem 0 3rem 0;
  @media (min-width: 767px) {
    padding: 8rem 0 3rem 0;
  }
  .hero-heading {
    color: var(--pink);
    font-family: 'gilroy-light', sans-serif;
    font-weight: 100;
    margin: 0 0 1rem 0;
    max-width: 30rem;
    text-transform: none;
    @media (min-width: 767px) {
      margin: 0 0 2rem 0;
    }
  }
  .hero__text, p {
    padding: 0 2rem 2rem 0;
    @media (min-width: 992px) {
      max-width: 30rem;
      padding: 0 12rem 2rem 0;
    }
  }
  .hero-column {
    justify-content: center;
  }
  .panel-box {
    margin-top: 2rem;
    position: relative;
    display: flex;
    justify-content: center;
    min-height: 18rem;
    @media (min-width: 992px) {
      margin-top: unset;
      min-height: 28rem;
    }
    .hero-panel {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.75s ease-in-out;
      width: 16rem;
      @media (min-width: 992px) {
        width: 25rem;
      }
      &.active {
        opacity: 1;
        transition: opacity 0.75s ease-in-out;
      }
      &:nth-child(1){
        .hero-label {
          background-color: var(--pink);
        }
      }
      &:nth-child(2){
        .hero-label {
          background-color: var(--lightblue);
        }
      }
      &:nth-child(3){
        .hero-label {
          background-color: var(--orange);
        }
      }
      &:nth-child(4){
        .hero-label {
          background-color: var(--green);
        }
      }
    }
    .hero-image {
      width: 16rem;
      height: 16rem;
      aspect-ratio: 1 / 1;
      object-fit: cover;
      object-position: center;
      display: block;
      position: relative;
      top: 0;
      z-index: 10;
      @media (min-width: 991px) {
        width: 25rem;
        height: 25rem;
        top: 3rem;
      }
    }
    .hero-bg {
      background-color: var(--darkblue);
      height: 10rem;
      right: -2rem;
      position: absolute;
      top: -2rem;
      width: 10rem;
      z-index: 1;
      @media (min-width: 992px) {
        height: 15rem;
        right: -3rem;
        top: 0;
        width: 15rem;
      }
    }
    .hero-label {
      align-items: center;
      background-color: #424242;
      border: 1px solid var(--white);
      bottom: -2rem;
      color: var(--white);
      display: flex;
      flex-direction: column;
      height: 9rem;
      justify-content: center;
      left: -2rem;
      position: absolute;
      width: 9rem;
      z-index: 20;
      @media (min-width: 992px) {
        bottom: -1rem;
        height: 10rem;
        left: -3rem;
        width: 10rem;
      }
      .hero-icon {
        height: 3rem;
        margin-bottom: 1rem;
        width: 3rem;
        filter: invert(1) brightness(1) saturate(1);
      }
      .hero-label__title {
        color: var(--white);
        font-family: 'gilroy-bold', sans-serif;
        font-size: 1.5rem;
        text-align: center;
        width: 80%;
      }
    }
  }
  .hero-btn {
    background-color: var(--pink);
    border: none;
    color: var(--white);
    display: inline-block;
    margin: 5rem auto 0 auto;
    position: relative;
    width: 12rem;
  }
}
</style>
